/**
 * Krok MAP3b — EXPORT MAPY (`E4` PNG, `J1` PDF prehledu parcely).
 *
 * Tenhle modul je POUZE pravidla: co smi do exportu vstoupit, jak se vystup
 * jmenuje a jestli v nem je logo kancelare. Zadne platno, zadny `fetch` —
 * kresleni resi UI (MapLibre na verejnem webu, OpenLayers v adminu) a sazbu
 * PDF `@reos/reports`. Duvod: pravidla urovni musi cist VSECHNY tri cesty
 * (verejny web, admin, API) ze stejneho mista (CLAUDE.md §8 bod 2), zatimco
 * kresleni je u kazde z nich jine.
 */
import { canAccessMapFeature, hasMapEntitlement, MAP_EXPORT_BRAND_LEVEL, } from './entitlements.js';
/**
 * CO SMI UROVEN VIDET — a tedy co smi byt i v exportu.
 *
 * Prepinac zamcene vrstvy je v UI `disabled`, ale stav vrstev se cte z URL
 * (`?tema=…`), takze rucne poupravovany odkaz do nej zamcenou vrstvu dostane.
 * Tahle funkce je proto zabrana PRED kreslenim: co se nenakresli, to nemuze
 * byt ani ve vyvezenem obrazku („anonym nedostane placene vrstvy v exportu",
 * akceptacni kriterium MAP3b). Jedna funkce pro obrazovku i export zamerne —
 * dve kopie pravidla by se rozesly (CLAUDE.md §8 bod 2).
 */
export function allowedMapLayers(layers, have) {
    return layers.filter((layer) => hasMapEntitlement(have, layer.level));
}
/** `true`, kdyz uroven staci na export obrazku mapy (`E4`). */
export function canExportMapImage(have) {
    return canAccessMapFeature(have, 'E4');
}
/** `true`, kdyz uroven staci na PDF prehledu parcely (`J1`). */
export function canExportParcelPdf(have) {
    return canAccessMapFeature(have, 'J1');
}
/**
 * `true`, kdyz do vystupu patri LOGO KANCELARE (`MAP_EXPORT_BRAND_LEVEL`).
 * Anonym a uroven koupeneho reportu dostanou dokument bez loga — jen
 * s „Powered by" provozovatele, viz `@reos/reports` → `parcel-overview.ts`.
 */
export function exportShowsOfficeBrand(have) {
    return hasMapEntitlement(have, MAP_EXPORT_BRAND_LEVEL);
}
/**
 * Jmeno souboru, ktere uvidi clovek ve stazenych. Parcelni cislo nese
 * lomitko (`38/13`) a diakritiku z nazvu k. u., takze se prevadi na
 * bezpecny zaklad — jmeno souboru je vystup pro souborovy system, ne text
 * v UI, proto se tu NEprekladá a nejde pres i18n katalog.
 */
export function mapExportFileName(input) {
    const slug = (input.parcelLabel ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/gu, '')
        .replace(/[^a-zA-Z0-9]+/gu, '-')
        .replace(/^-+|-+$/gu, '')
        .toLowerCase();
    const parts = ['mapa', slug === '' ? null : slug, input.today.slice(0, 10)].filter((part) => part !== null);
    return `${parts.join('-')}.${input.extension}`;
}
//# sourceMappingURL=export.js.map